var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"fla__card"},[_c('FilmmakerDetailsForm',_vm._b({ref:"formFilmmakerDetails",attrs:{"value":_vm.value,"showEmail":""},on:{"input":function (newValue) { return _vm.$emit('input', newValue); }}},'FilmmakerDetailsForm',_vm.$attrs,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a65e4bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Licenses/CommonLicenseComponents/AppSpecificLicenseComponent/AppYourDetails.vue
// module id = 598
// module chunks = 0 1 2 3